export default {
  'delegationConfigurations.title': 'Configurations',
  'delegationConfigurations.description':
    'Configure environments, processes and delegated users for this delegation.',

  'delegationConfigurations.form.environment': 'Environment',
  'delegationConfigurations.form.process': 'Process',
  'delegationConfigurations.form.name': 'Delegated User',
};
